define('Facets.Browse.View.Extension', [
  'Facets.Browse.View',
  'Facets.ItemCell.View',
  'Backbone.CollectionView',
  'facets_items_collection_view_cell.tpl',
  'facets_items_collection_view_row.tpl',
  'facets_items_collection.tpl',
  'underscore',
], function (
  FacetsBrowseView,
  FacetsItemCellView,
  BackboneCollectionView,
  facets_items_collection_view_cell_tpl,
  facets_items_collection_view_row_tpl,
  facets_items_collection_tpl,
  _
) {
  'use strict';

  return _.extend(FacetsBrowseView.prototype, {
    getDisplayOptions: function () {
      var self = this;

      return _.find(this.itemsDisplayOptions, function (option) {
        return option.id === self.translator.getOptionValue('display');
      });
    },

    childViews: _.extend(FacetsBrowseView.prototype.childViews, {
      'Facets.Items': function () {
        var display_option = this.getDisplayOptions();
        // display_option.columns = 6;

        return new BackboneCollectionView({
          childTemplate: display_option.template,
          childView: FacetsItemCellView,
          childViewOptions: { application: this.application },
          viewsPerRow: parseInt(display_option.columns, 10),
          collection: this.model.get('items'),
          cellTemplate: facets_items_collection_view_cell_tpl,
          rowTemplate: facets_items_collection_view_row_tpl,
          template: facets_items_collection_tpl,
          context: { keywords: this.translator.getOptionValue('keywords') },
        });
      },
    }),
  });
});
